import { SVG } from "./svg";
import { Size } from "./size";
import { Graph } from "./graph";

export class SingleNumber {

  static render(svg: SVGElement, id: string, title: string, number: number | null, color: string, inset: number = 12): Size {
    const height = 150;
    const width = 400;

    svg.setAttribute("viewBox", "0 0 " + width + " " + height + "");

    Graph.render_title(svg, id, title, width, inset);

    const num = document.createElementNS("http://www.w3.org/2000/svg", "text");
    if (number) {
      num.innerHTML = Graph.compact_number(number);
    }
    num.setAttribute("x", inset.toString());
    num.setAttribute("y", "120");
    num.style.fontWeight = "bold";
    num.style.fontSize = "80px";
    num.style.letterSpacing = "-4px";
    num.style.fontFamily = SVG.font;
    num.setAttribute("fill", color);
    num.classList.add("vertbar-amount");
    const title_el = document.createElementNS("http://www.w3.org/2000/svg", "title");
    if (number) {
      title_el.innerHTML = Graph.formated_number(number);
    }
    num.appendChild(title_el);

    svg.appendChild(num);

    return {
      width: width,
      height: height,
    }
  }

}